/** UI helpers for DepenseType.expenseKind (OPEX / CAPEX / OTHER). */

export function expenseKindTagLabelKey(v) {
  if (v === "CAPEX") return "comptabilite.expenseKindCapex";
  if (v === "OTHER") return "comptabilite.expenseKindOther";
  return "comptabilite.expenseKindOpex";
}

export function expenseKindTagColor(v) {
  if (v === "CAPEX") return "purple";
  if (v === "OTHER") return "orange";
  return "blue";
}
